module.exports = __webpack_public_path__ + "img/3EA78C62.12387877.png";